export default class SubscriptionFormPlus extends HTMLElement {
	constructor() {
		super();
		this.isValidEmail = false;
		this.isAcceptedCGV = false;

		// First Form
		this.elForm = this.querySelector('#contact_form');
		this.elInputEmail = this.elForm.querySelector('#NewsletterForm');
		this.elCheckboxRGPD = this.querySelector('#nl-rgpd');
		this.elBtnSubmit = this.querySelector('#Subscribe');

		// Second Form (aka Topics)
		this.elFormTopics = this.querySelector('#contact_form_topics');
		if (this.elFormTopics) {
			this.elInputEmailTopics = this.elFormTopics.querySelector('#inputTopics');
		}

		// Message
		this.elMsgErrorEmail = this.querySelector('.js-nl-mail-error');
		this.elMsgSuccess = this.querySelector('.js-nl-success');
	}

	connectedCallback() {
		this.elCheckboxRGPD.addEventListener('change', (e) => {
			this.isAcceptedCGV = e.target.checked;
			this.requiredInfo();
		});

		this.elInputEmail.addEventListener('input', (e) => {
			this.isValidEmail = this.validateEmail(e.target.value);
			this.requiredInfo();
		});

		this.elForm.addEventListener('submit', (e) => {
			this.formSubmit(e);
		});

		if (this.elFormTopics) {
			this.elFormTopics.addEventListener('submit', (e) => {
				this.formTopicsSubmit(e);
			});
		}
	}

	requiredInfo() {
		if (this.isValidEmail && this.isAcceptedCGV) {
			this.elBtnSubmit.removeAttribute('disabled');
		} else {
			this.elBtnSubmit.setAttribute('disabled', true);
		}
	}

	formSubmit(e) {
		if (this.validateEmail(this.elInputEmail.value)) {
			this.elMsgErrorEmail.classList.add('u-hidden');
			if (this.elFormTopics) {
				this.elForm.setAttribute('hidden', '');
				this.elFormTopics.removeAttribute('hidden');
				this.elInputEmailTopics.value = this.elInputEmail.value;
			} else {
				this.elMsgSuccess.removeAttribute('hidden');
			}
		} else {
			e.preventDefault();
			this.elMsgErrorEmail.classList.remove('u-hidden');
		}
	}

	formTopicsSubmit() {
		this.elFormTopics.setAttribute('hidden', '');
		this.elMsgSuccess.removeAttribute('hidden');
	}

	validateEmail(email) {
		const re =
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}
}
